module.exports = __webpack_public_path__ + "fonts/tragic-marker-regular.2c5951f6.woff2";